import { createSlice } from "@reduxjs/toolkit";
import { adminGetPasswordConfig } from "./passwordConfigurationActions";
import { IPasswordConfig } from "./passwordConfigurationType";

const initialState: IPasswordConfig = {
  passwordConfigData: {
    minimumLength: 0,
    maximumLength: 0,
    upperCase: false,
    upperCaseValue: 0,
    lowerCase: false,
    lowerCaseValue: 0,
    specialCharacters: false,
    specialCharactersValue: "",
    specialCharactersLength: 0,
    numericCharacters: false,
    numericCharactersValue: 0,
    passwordExpiry: false,
    passwordExpiryValue: 0,
  },
};

const adminPasswordConfigSlice = createSlice({
  name: "adminPasswordConfig",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(adminGetPasswordConfig.fulfilled, (state, { payload }) => {
      state.passwordConfigData = payload.data;
    });
  },
});

export default adminPasswordConfigSlice.reducer;
